<!-- Add Gateways modal -->

<!-- <div class="modal-dialog modal-dialog-centered"> -->
<div class="modal-content">
    <div class="modal-header bg-primary text-white">
        <h5 class="modal-title"> {{ thirdpartyUpdateData?.id? 'Update Billing urls' : 'Add Billing urls' }} </h5>
        <button type="button" (click)="dismissModal()" class="btn-close text-white" aria-label="Close"></button>
    </div>
    <div class="modal-body">
        <form class="form-horizontal" [formGroup]="creategatewayForm">

            <div class="mb-3">
                <label>Project Name <span class="required">*</span></label>
                <ng-select [items]="listofProjects" formControlName="projectId" (change)="valueChange($event)"
                    [multiple]="false" bindLabel="name" bindValue="id" [placeholder]="'Select...'"></ng-select>
                @if(submitted && gatewayControls['projectId'].errors){
                <div class="invalid-feedback">
                    @if(gatewayControls['projectId'].errors['required']){
                    <div>{{fileValidations.project.required}}</div>}

                </div>}

            </div>


            <div class="mb-3">
                <label>End Point Name<span class="required">*</span></label>
                <!-- <input type="text" class="form-control" formControlName="endpointName" id="endpointName" />
                @if(submitted && gatewayControls['endpointName'].errors){
                <div class="invalid-feedback">
                    @if(gatewayControls['endpointName'].errors['required']){
                    <div>{{fileValidations.endpointName.required}}</div>}

                </div>} -->
                <input class="form-control" formControlName="endpointName" id="endpointName" />

                @if((submitted || gatewayControls['endpointName']?.touched) && gatewayControls['endpointName']?.errors)
                {

                <div class="invalid-feedback">

                    @if(gatewayControls['endpointName']?.errors?.['required']) {
                    <div>{{fileValidations.endpointName.required}}</div>
                    }

                    @if(gatewayControls['endpointName']?.errors?.['maxlength']) {
                    <div>{{fileValidations.endpointName.maxLengthValidator}}</div>
                    }

                    @if(gatewayControls['endpointName']?.errors?.['whitespace']) {
                    <div>{{ fileValidations.endpointName.whitespace }}</div>
                    }

                </div>
                }



            </div>
            
<div class="mb-3">
  <label>Type <span class="required">*</span></label>

  <ng-select
    [items]="endpointTypes"
    formControlName="type"
    bindLabel="name"
    bindValue="name"
    [multiple]="false"
    [clearable]="false"
    [placeholder]="'Select Type'">
  </ng-select>

  @if ((submitted || gatewayControls['type'].touched)
       && gatewayControls['type'].errors) {
    <div class="invalid-feedback d-block">
      @if (gatewayControls['type'].errors['required']) {
        <div>Type is required.</div>
      }
    </div>
  }
</div>
            <div class="col-lg-4 mb-3">
                <div class="mb-3" style="margin-top: 30px;">
                    <label for="b">Is HMWSSB </label>&nbsp;&nbsp;
                    <ui-switch [ngClass]="{
                                                        'switch-checked': creategatewayForm.controls['ishmwssb'].value,
                                                        'switch-unchecked': !creategatewayForm.controls['ishmwssb'].value
                                                    }" formControlName="ishmwssb"
                        [uncheckedLabel]="'No'" [checkedLabel]="'Yes'" size="small" class="me-1"
                        >
                    </ui-switch>
                </div>
            </div>

            <div class="mb-3">
                <label>Url <span class="required">*</span></label>
                <input type="url" class="form-control" formControlName="url" id="url" />
                @if((submitted || gatewayControls['url'].touched)&&
                gatewayControls['url'].errors) {
                <div class="invalid-feedback">
                    @if(gatewayControls['url'].errors['required']) {
                    <div>{{fileValidations.url.required}}</div>
                    }
                    @if(gatewayControls['url'].errors['pattern']) {
                    <div>{{fileValidations.url.patternValidation}}</div>}
                </div>}
                <!--  @if(submitted && gatewayControls['url'].errors){
                        <div class="invalid-feedback">
                            @if(gatewayControls['url'].errors['required']){
                            <div>{{fileValidations.url.required}}</div>}
                        </div>} -->

            </div>
              <div class="mb-3">
                <label>API Key Token</label>
                <input type="apikeyToken" class="form-control" formControlName="apikeyToken" id="apikeyToken" placeholder="Enter api key token" />
                @if((submitted || gatewayControls['apikeyToken'].touched)&&
                gatewayControls['apikeyToken'].errors) {
                <div class="invalid-feedback">
                    @if(gatewayControls['apikeyToken'].errors['required']) {
                    <div>{{fileValidations.apiKeyToken.required}}</div>
                    }
                    @if(gatewayControls['apikeyToken'].errors['pattern']) {
                    <div>{{fileValidations.apiKeyToken.patternValidation}}</div>}
                </div>}


            </div>
            <div class="d-flex gap-3 mb-3" *ngIf="gatewayControls['ishmwssb'].value">
  <div class="form-check">
    <input class="form-check-input" type="radio" id="radioDefault1"
           formControlName="hmwssbType" [value]="true">
    <label class="form-check-label" for="radioDefault1">Immediate</label>
  </div>
  <div class="form-check">
    <input class="form-check-input" type="radio" id="radioDefault2"
           formControlName="hmwssbType" [value]="false">
    <label class="form-check-label" for="radioDefault2">Schedule</label>
  </div>
</div>



          
            <div class="mb-3">
                <label>Description</label>
                <input type="text" class="form-control" formControlName="description" id="description" />

            </div>




        </form>
    </div>
    <div class="modal-footer">
        @if(thirdpartyUpdateData?.id){
        <button type="button" class="btn btn-primary waves-effect waves-light"
            (click)="saveThirdParty('Update')">Update</button>}
        @else{
        <button type="button" class="btn btn-primary waves-effect waves-light" (click)="saveThirdParty('Create')">Save
           </button>}

        <!-- Add Gateways modal End  -->
    </div>
</div>
<!-- </div> -->